import moment from 'moment';
import { formatMoney, getIntervalLabel } from '../screens/checkout/planUtils';

export const extractSubscriptions = (payload) => {
  if (!payload) {
    return [];
  }
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload.subscriptions)) {
    return payload.subscriptions;
  }
  if (Array.isArray(payload.results)) {
    return payload.results;
  }
  if (payload.subscription) {
    return [payload.subscription];
  }
  if (
    payload.stripe_subscription_id ||
    payload.id ||
    payload.pk ||
    payload.status
  ) {
    return [payload];
  }
  return [];
};

export const getSubscriptionPk = (subscription) => {
  if (!subscription) {
    return null;
  }
  return (
    subscription.stripe_subscription_id ||
    subscription.pk ||
    subscription.id ||
    null
  );
};

export const getPlanName = (subscription) =>
  subscription.stripe_subscription_plan_name ||
  subscription.product_name ||
  subscription.plan_name ||
  'Suscripción';

export const getPlanPriceLabel = (subscription) => {
  const currency = (
    subscription.stripe_subscription_currency ||
    subscription.currency ||
    'USD'
  ).toUpperCase();

  const amount =
    subscription.stripe_subscription_price != null
      ? Number(subscription.stripe_subscription_price)
      : Number(subscription.amount);

  if (!amount && amount !== 0) {
    return null;
  }

  const interval =
    subscription.stripe_subscription_interval || subscription.interval;
  const intervalLabel = getIntervalLabel(interval, 1);

  return `${formatMoney(amount, currency)}${
    intervalLabel ? ` ${intervalLabel}` : ''
  }`;
};

export const formatSubscriptionDate = (value) => {
  if (!value) {
    return null;
  }
  if (typeof value === 'number') {
    const ms = value > 1e12 ? value : value * 1000;
    return moment(ms).format('DD/MM/YYYY');
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : null;
};

export const getStatusKey = (subscription) => {
  if (!subscription) {
    return null;
  }
  if (subscription.cancel_at_period_end) {
    return 'cancel_at_period_end';
  }
  return (subscription.status || '').toLowerCase() || null;
};

export const getStatusLabel = (statusKey) => {
  const labels = {
    active: 'Activa',
    trialing: 'Período de prueba',
    past_due: 'Pago pendiente',
    canceled: 'Cancelada',
    unpaid: 'Impaga',
    incomplete: 'Incompleta',
    incomplete_expired: 'Expirada',
    paused: 'Pausada',
    cancel_at_period_end: 'Cancelación programada',
  };
  return labels[statusKey] || statusKey || 'Sin estado';
};

export const getStatusColor = (statusKey) => {
  if (statusKey === 'active' || statusKey === 'trialing') {
    return '#2e7d32';
  }
  if (statusKey === 'cancel_at_period_end' || statusKey === 'paused') {
    return '#ed6c02';
  }
  if (
    statusKey === 'past_due' ||
    statusKey === 'unpaid' ||
    statusKey === 'incomplete'
  ) {
    return '#d32f2f';
  }
  return '#757575';
};

export const canCancelSubscription = (subscription) => {
  if (!subscription || subscription.cancel_at_period_end) {
    return false;
  }
  const status = (subscription.status || '').toLowerCase();
  return status === 'active' || status === 'trialing';
};

export const canReactivateSubscription = (subscription) => {
  if (!subscription) {
    return false;
  }
  if (subscription.cancel_at_period_end) {
    return true;
  }
  const status = (subscription.status || '').toLowerCase();
  return status === 'canceled' || status === 'paused';
};

export const ACTIVE_SUBSCRIPTION_STATUSES = ['active', 'trialing'];

export const hasValidSubscriptionAccess = (payload) => {
  const subscriptions = extractSubscriptions(payload);
  return subscriptions.some((subscription) => {
    const status = (subscription.status || '').toLowerCase();
    return ACTIVE_SUBSCRIPTION_STATUSES.includes(status);
  });
};
